// File generated by create-react-app on 25-03-2024.

import React from 'react';
import ReactDOM from 'react-dom/client';

import {App} from './App';

/**
 *
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Create react-dom, with reference to the html element, with the id root.
 * @version 0.1.0
 */
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
